import { URLSearchParams } from 'core-js/modules/web.url-search-params';
import { dataSet } from '@/main';

export const Theme = {
    Elektramat: 'elektramat',
    Kabel24: 'kabel-24',
};

const isValidTheme = (desiredTheme) => {
    return Object.values(Theme).includes(desiredTheme);
};

export default {
    namespaced: true,
    state: {
        currentTheme: Theme.Elektramat,
    },
    getters: {
        checkIfThemeIsActive: (state) => (theme) => {
            if (!isValidTheme(theme)) {
                return false;
            }

            return state.currentTheme === theme;
        },
        getActiveTheme: (state) => {
            return state.currentTheme;
        },
        getAvailableThemes: () => {
            return Theme;
        }
    },
    actions: {
        enableHotKeyThemeSwitch({ state, commit }) {
            window.addEventListener('keydown', function (e) {
                if (e.key !== '`') {
                    return;
                }

                const themes = Object.values(Theme);

                const currentIndex = themes.findIndex(
                    (theme) => theme === state.currentTheme,
                );

                let newIndex = currentIndex + 1;
                if (newIndex > themes.length - 1) {
                    newIndex = 0;
                }

                const newTheme = themes[newIndex];
                if (newTheme === undefined) {
                    console.warn(
                        `theme at index "${newIndex}" is undefined`,
                        themes,
                    );

                    return;
                }

                commit('setCurrentTheme', newTheme);
            });
        },
        initializeTheme({ commit }) {
            const urlParamTheme = new URLSearchParams(window.location.search).get('theme');
            if (urlParamTheme) {
                if (isValidTheme(urlParamTheme)) {
                    commit('setCurrentTheme', urlParamTheme);

                    return;
                }

                console.warn(`theme \`${urlParamTheme}\` is not valid, attempting dataset`);
            }

            const dataSetTheme = dataSet.theme;
            if (dataSetTheme) {
                if (!isValidTheme(dataSetTheme)) {
                    console.warn(`theme \`${dataSetTheme}\` is not valid, using \`${Theme.Elektramat}\` instead`);

                    return;
                }

                commit('setCurrentTheme', dataSet.theme);
            }
        },
    },
    mutations: {
        setCurrentTheme(state, desiredTheme) {
            if (typeof desiredTheme !== 'string') {
                throw new Error('`desiredTheme` must be a string');
            }

            state.currentTheme = desiredTheme;
        },
    },
};
